import { IFinalResponse, Utils } from '../Core';
import Machines from '../Flows';
import {
  CountriesTypes,
  GeoLocationTypes,
  HeadlessDeliveryTypes,
  PartnerTokenTypes,
  UploadFileS3Types,
  ZipCodeTypes,
  ListOfValuesTypes,
  CmsContentTypes,
  ListPartnerTypeTypes,
} from '../Types';

/**
 * @description Busca dados no mapa por geolocalização, endereço, localização predetiva, etc
 *
 * @param params GeoLocationServiceRequestType
 * @returns Promise IFinalResponse
 */
export const getGeoLocation = (
  params: GeoLocationTypes.GeoLocationServiceRequestType,
): Promise<IFinalResponse> =>
  Utils.callServiceMachine(Machines.onGeoLocation.machine(), params);

/**
 * @description Cria busca interativa no Liferay (CMS)
 *
 * @param params HeadlessDeliveryServiceRequestType
 * @returns Promise IFinalResponse
 */
export const findHeadlessDelivery = (
  params: HeadlessDeliveryTypes.HeadlessDeliveryServiceRequestType,
): Promise<IFinalResponse> =>
  Utils.callServiceMachine(Machines.onHeadlessDelivery.machine(), params);

/**
 * @description Este serviço é parecido com o findHeadlessDelivery, porém tenta deixar os parametros de entrada como argumento
 *
 * @param params keys, fields
 * @returns Promise IFinalResponse
 */
export const getHeadlessDelivery = (
  keys: string[],
  fields?: string[],
): Promise<IFinalResponse> => {
  const filter: HeadlessDeliveryTypes.HeadlessDeliverySearchType[] = keys.map(
    (value) => ({
      param: 'friendlyUrlPath',
      conditional: 'eq',
      value,
    }),
  );

  return Utils.callServiceMachine(Machines.onHeadlessDelivery.machine(), {
    flatter: true,
    filter,
    fields,
  });
};

/**
 * @description Upload de arquivos no S3 por diretorio pré-definido
 *
 * @param params UploadFileS3ServiceRequestType
 * @returns Promise IFinalResponse
 */
export const uploadFileS3 = (
  params: UploadFileS3Types.UploadFileS3ServiceRequestType,
): Promise<IFinalResponse> =>
  Utils.callServiceMachine(Machines.onUploadFileS3.machine(), params);

/**
 * @description Busca URL do Parceiro
 *
 * @param params PartnerTokenServiceRequestType
 * @returns Promise IPartnerTokenServiceResponse
 */
export const partnerToken = (
  params: PartnerTokenTypes.PartnerTokenServiceRequestType,
): Promise<PartnerTokenTypes.IPartnerTokenServiceResponse> =>
  Utils.callServiceMachine(Machines.onPartnerToken.machine(), params);

/**
 * @description Lista de países com nome visual, nome para o Siebel, sigla iso2, sigla iso3 e DDI.
 *
 * @param params CountriesServiceRequestType
 * @returns Promise ICountriesServiceResponse
 */
export const getListCountry = (
  params?: CountriesTypes.CountriesServiceRequestType,
): Promise<CountriesTypes.ICountriesServiceResponse> =>
  Utils.callServiceMachine(Machines.onGetListCountry.machine(), params);

/**
 * @description Pega dados de endereço do ZipCode informado (Ex. CEP)
 *
 * @param params GenerateTokenSmsServiceRequestType
 * @returns Promise IMessageResponse
 */
export const getZipCode = (
  params: ZipCodeTypes.IZipCodeServiceRequest,
): Promise<ZipCodeTypes.IZipCodeServiceResponse> => {
  return Utils.callServiceMachine(Machines.onGetZipCode.machine(), params);
};

/**
 * @description Returns multiple configurable lists
 * @param params IListOfValuesServiceRequestType
 * @returns Promise<IListOfValuesServiceResponse>
 */
export const getListOfValues = (
  params: ListOfValuesTypes.IListOfValuesServiceRequestType,
): Promise<ListOfValuesTypes.IListOfValuesServiceResponse> => {
  return Utils.callServiceMachine(Machines.onGetListOfValues.machine(), params);
};

/**
 * @description Returns multiple configurable lists
 * @param params IListOfValuesServiceRequestType
 * @returns Promise<IListOfValuesServiceResponse>
 */
export const getCmsContent = (
  params: CmsContentTypes.CmsContentRequestType,
): Promise<CmsContentTypes.ICmsContentServiceResponse> => {
  return Utils.callServiceMachine(Machines.onGetCmsContent.machine(), params);
};

/**
 * @description Returns smiles partners and products
 */
export const getPartners = (
  params?: ListPartnerTypeTypes.ListPartnerTypeRequestType,
): Promise<ListPartnerTypeTypes.IListPartnerTypeServiceResponse> => {
  return Utils.callServiceMachine(Machines.onListPartnerType.machine(), params);
};

export default {
  getGeoLocation,
  findHeadlessDelivery,
  getHeadlessDelivery,
  partnerToken,
  uploadFileS3,
  getListCountry,
  getZipCode,
  getListOfValues,
  getCmsContent,
  getPartners,
};
